import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import { IWorkflowCollectionState } from '../../../workflow/store/workflow.reducer';
import { Store, select } from '@ngrx/store';
import {getWorkflowReducerState, getWorkflowStates, isWorkflowCleanedUp} from '../../../workflow/store/workflow.selector';
import { takeUntil } from 'rxjs/operators';
import { Configuration } from '@shared/models/configuration';
import {CleanWorkflowDataAction, CreateWorkflowAction} from '../../../workflow/store/workflow.actions';
import {CommandService} from '@core/services/command.service';
import { AddManageTransactionSelectedCommand } from '../../commands/dac6-reporter.command';
import {ActivatedRoute, Router} from '@angular/router';
import {Guid} from 'guid-typescript';
import {getCheckSum, ParticleState} from '@shared/store/reducers/particle.reduer';
import {GetCheckSumAction} from '@shared/store/actions/particle.actions';


@Component({
    standalone: false,
    selector: 'particle-manage-transaction',
  templateUrl: './manage-transaction.component.html',
  styleUrls: ['./manage-transaction.component.css']
})
export class ManageTransactionComponent implements OnInit, OnDestroy {
  workflowTemplate: string;
  apiEndpointKey: string;
  workflowState$: any;
  cleanedUp$: any;
  unsubscribe$ = new Subject<void>();
  hasWorkflowId = false;
  workflowId: string;
  checkSumId$: Observable<any>;
  unSubscribe$ = new Subject<void>();
  executionId: string;
  arrangement: any;
  currency: any;
  consolidatedTransactions: any[];

  constructor(private workflowStore: Store<IWorkflowCollectionState>, private  commandService: CommandService, private router: Router, private particleStore: Store<ParticleState>, private activatedRoute: ActivatedRoute) {
    this.apiEndpointKey = 'Dac6Api';
    this.workflowTemplate = 'dac6-manage-transaction-workflow';
    this.particleStore.select(getCheckSum('[CompanyId]-dac6-manage-transaction-workflow')).pipe(takeUntil(this.unSubscribe$)).subscribe((id: string) => {
      this.workflowId = id;
    });
    this.workflowStore.dispatch(new CleanWorkflowDataAction(this.workflowId));

  }

  ngOnInit() {
    let hasFinished = false;
    const config = Configuration.getConfig('Dac6Api');
    const endpointUrl = `${config}Command/CreateWorkflow`;
    const action = new CreateWorkflowAction(endpointUrl, this.workflowId, 'Manage Transaction', 'dac6-manage-transaction-workflow');
    this.workflowStore.dispatch(action);
    this.workflowState$ = this.workflowStore.pipe(select(getWorkflowStates, this.workflowId));
    this.workflowState$.pipe(takeUntil(this.unSubscribe$)).subscribe(states => {
      if (states) {
        const state = states.find(s => s.Id === 'Dac6ManageTransaction');
        if (state) {
          const input = state.Inputs.find(o => o.Name === 'ExecutionWorkflowId');
          if (input) {
            this.executionId = input.Value;
          }
        }
      }
    });
    this.cleanedUp$ = this.workflowStore.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.pipe(takeUntil(this.unSubscribe$)).subscribe(state => {
      if (state === 'Finished' || state === 'Cancelled') {
        // this.router.navigate(EntityDataConfig.getEntityDataContentUrl());
        if (!hasFinished && state === 'Finished' && this.executionId) {
          hasFinished = true;
          let caseId = '';
          let arrangementGuid = '';
          let arrangementId = '';
          let currencyCode = '';
          let currencyName = '';
          if(this.arrangement){
            caseId = this.arrangement.caseId;
            arrangementGuid = this.arrangement.id;
            arrangementId = this.arrangement.arrangementId;
          }
          if(this.currency){
            currencyCode = this.currency.currencyCode;
            currencyName = this.currency.currencyName;
          }
          const command = new AddManageTransactionSelectedCommand(this.executionId, caseId, arrangementGuid,
            arrangementId, this.consolidatedTransactions, currencyCode, currencyName);
          this.commandService.executeCommand(command).subscribe(res=>{
            this.router.navigate(['..'], {relativeTo: this.activatedRoute});
          });

        }
        if(state === 'Cancelled'){
          this.router.navigate(['..'], {relativeTo: this.activatedRoute});
        }

      }
    });
  }

  onGridCellValueChange(event) {
    switch (event.id){
      case 'Case':
        this.arrangement = event.value;
        break;
      case 'Currency':
        this.currency = event.value;
        break;
      case 'ConsolidatedTransactions':
        this.consolidatedTransactions = event.value;
        break;
    }
    console.log('cell value change', event);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
